"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _IntegrationSetup = _interopRequireDefault(require("./IntegrationSetup"));

var _axios = _interopRequireDefault(require("axios"));

var _Tabs = require("./components/productboard/Tabs");

var _PanelItems = require("./components/PanelItems");

var _UninstallModal = _interopRequireDefault(require("./components/UninstallModal"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _constants = require("@insided/shared/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ProductboardIntegration = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductboardIntegration, _Component);

  var _super = _createSuper(ProductboardIntegration);

  function ProductboardIntegration(props) {
    var _props$isInstalled, _props$isEnabled, _props$apiToken, _props$isEnabled2, _props$apiToken2;

    var _this;

    (0, _classCallCheck2.default)(this, ProductboardIntegration);
    _this = _super.call(this, props);
    _this.state = {
      isInstalled: (_props$isInstalled = props.isInstalled) !== null && _props$isInstalled !== void 0 ? _props$isInstalled : false,
      isNoteCreationSettingEnabled: (_props$isEnabled = props.isEnabled) !== null && _props$isEnabled !== void 0 ? _props$isEnabled : false,
      accessToken: (_props$apiToken = props.apiToken) !== null && _props$apiToken !== void 0 ? _props$apiToken : '',
      showActionButtons: false,
      storedState: {
        isNoteCreationSettingEnabled: (_props$isEnabled2 = props.isEnabled) !== null && _props$isEnabled2 !== void 0 ? _props$isEnabled2 : false,
        accessToken: (_props$apiToken2 = props.apiToken) !== null && _props$apiToken2 !== void 0 ? _props$apiToken2 : ''
      },
      activeTab: 0,
      showUnsavedChangesModal: false,
      showUninstallModal: false
    };
    _this.onNoteCreationSettingChanged = _this.onNoteCreationSettingChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetNoteCreationSetting = _this.resetNoteCreationSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveNoteCreationSetting = _this.saveNoteCreationSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.setActiveTab = _this.setActiveTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.setSelectedPanel = _this.setSelectedPanel.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetInstallationTab = _this.onResetInstallationTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetIntegrationTab = _this.onResetIntegrationTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.onInstall = _this.onInstall.bind((0, _assertThisInitialized2.default)(_this));
    _this.onUninstall = _this.onUninstall.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetAccessToken = _this.onResetAccessToken.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeModal = _this.closeModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.displayUnsavedChangedModal = _this.displayUnsavedChangedModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickUninstallButton = _this.onClickUninstallButton.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeUninstallModal = _this.closeUninstallModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.dismissMessage = _this.dismissMessage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ProductboardIntegration, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        messageType: undefined
      });
      window.addEventListener('beforeunload', function (e) {
        return _this2.onUnload(e);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', this.onUnload);
    }
  }, {
    key: "onUnload",
    value: function onUnload(e) {
      if (this.checkPanelHasUnsavedChanges()) {
        e.preventDefault();
        e.returnValue = '';
      }
    }
  }, {
    key: "checkPanelHasUnsavedChanges",
    value: function checkPanelHasUnsavedChanges() {
      var _this$state = this.state,
          accessToken = _this$state.accessToken,
          isNoteCreationSettingEnabled = _this$state.isNoteCreationSettingEnabled;
      var hasAccessTokenChanged = accessToken !== this.state.storedState.accessToken;
      var hasNoteCreationSettingChanged = isNoteCreationSettingEnabled !== this.state.storedState.isNoteCreationSettingEnabled;
      return hasAccessTokenChanged || hasNoteCreationSettingChanged;
    }
  }, {
    key: "setSelectedPanel",
    value: function setSelectedPanel(selectedPanel) {
      this.setState({
        selectedPanel: selectedPanel
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        showUnsavedChangesModal: false
      });
    }
  }, {
    key: "onNoteCreationSettingChanged",
    value: function onNoteCreationSettingChanged(value) {
      this.setState({
        isNoteCreationSettingEnabled: value,
        activePanel: 0,
        showActionButtons: true
      });
    }
  }, {
    key: "resetNoteCreationSetting",
    value: function resetNoteCreationSetting() {
      this.setState({
        isNoteCreationSettingEnabled: this.state.storedState.isNoteCreationSettingEnabled,
        showActionButtons: false,
        showUnsavedChangesModal: false
      });
    }
  }, {
    key: "onResetIntegrationTab",
    value: function onResetIntegrationTab(activeTab) {
      this.resetNoteCreationSetting();
      this.setState({
        activeTab: activeTab
      });
    }
  }, {
    key: "setActiveTab",
    value: function setActiveTab(selectedTab) {
      if (this.checkPanelHasUnsavedChanges()) {
        this.setState({
          showUnsavedChangesModal: true
        });
        return;
      }

      this.setState({
        activeTab: selectedTab
      });
    }
  }, {
    key: "saveNoteCreationSetting",
    value: function () {
      var _saveNoteCreationSetting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var successMessage, errorMessage, isNoteCreationSettingEnabled, requestUrl, updatedState;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  isSavingNoteCreationSetting: true
                });
                successMessage = 'Changes are saved successfully.';
                errorMessage = "Something went wrong, setting can't be updated. Please try again.";
                isNoteCreationSettingEnabled = this.state.isNoteCreationSettingEnabled;
                requestUrl = '/integration/productboard/disable';

                if (isNoteCreationSettingEnabled) {
                  requestUrl = '/integration/productboard/enable';
                }

                _context.prev = 6;
                _context.next = 9;
                return _axios.default.put(requestUrl);

              case 9:
                updatedState = _objectSpread({}, this.state.storedState);
                updatedState.isNoteCreationSettingEnabled = isNoteCreationSettingEnabled;
                this.setState({
                  storedState: updatedState,
                  message: successMessage,
                  messageType: 'success',
                  showActionButtons: false,
                  isSavingNoteCreationSetting: false
                });

                _publish.default.trackEvent('userevent', {
                  type: "Create Productboard notes from community posts ".concat(isNoteCreationSettingEnabled ? 'enabled' : 'disabled')
                });

                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](6);
                this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  showActionButtons: false,
                  isSavingNoteCreationSetting: false,
                  isNoteCreationSettingEnabled: this.state.storedState.isNoteCreationSettingEnabled
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 15]]);
      }));

      function saveNoteCreationSetting() {
        return _saveNoteCreationSetting.apply(this, arguments);
      }

      return saveNoteCreationSetting;
    }()
  }, {
    key: "dismissMessage",
    value: function dismissMessage() {
      this.setState({
        messageType: undefined,
        message: ''
      });
    }
  }, {
    key: "onInstall",
    value: function () {
      var _onInstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var successMessage, errorMessage, accessToken, result, _result$data, isEnabled, isInstalled, apiToken, updatedState, _data$error, data;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  validationErrorMessage: undefined,
                  isSavingCredentials: true
                });
                successMessage = 'All set! Productboard installed.';
                errorMessage = "Something went wrong, credentials can't be saved. Please try again.";
                accessToken = this.state.accessToken;

                if (!(accessToken === '')) {
                  _context2.next = 7;
                  break;
                }

                this.setState({
                  validationErrorMessage: 'Please fill in the required field.',
                  isSavingCredentials: false
                });
                return _context2.abrupt("return");

              case 7:
                _context2.prev = 7;
                _context2.next = 10;
                return _axios.default.post('/integration/productboard/install', {
                  apiToken: accessToken
                });

              case 10:
                result = _context2.sent;
                _result$data = result.data, isEnabled = _result$data.isEnabled, isInstalled = _result$data.isInstalled, apiToken = _result$data.apiToken;
                updatedState = _objectSpread({}, this.state.storedState);
                updatedState.accessToken = apiToken;
                this.setState({
                  isInstalled: isInstalled,
                  accessToken: apiToken,
                  isNoteCreationSettingEnabled: isEnabled,
                  storedState: updatedState,
                  message: successMessage,
                  messageType: 'success',
                  isSavingCredentials: false
                });
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](7);
                data = _context2.t0.response.data;
                this.setState({
                  validationErrorMessage: (_data$error = data.error) !== null && _data$error !== void 0 ? _data$error : errorMessage,
                  isSavingCredentials: false
                });

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 17]]);
      }));

      function onInstall() {
        return _onInstall.apply(this, arguments);
      }

      return onInstall;
    }()
  }, {
    key: "onResetAccessToken",
    value: function onResetAccessToken() {
      this.setState({
        accessToken: '',
        validationErrorMessage: undefined,
        showUnsavedChangesModal: false
      });
    }
  }, {
    key: "onResetInstallationTab",
    value: function onResetInstallationTab(activeTab) {
      this.onResetAccessToken();
      this.setState({
        activeTab: activeTab
      });
    }
  }, {
    key: "displayUnsavedChangedModal",
    value: function displayUnsavedChangedModal() {
      this.setState({
        showUnsavedChangesModal: true
      });
    }
  }, {
    key: "onUninstall",
    value: function () {
      var _onUninstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var errorMessage, updatedStoredState, _data$error2, data;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({
                  messageType: undefined
                });
                errorMessage = "Something went wrong, credentials can't be uninstalled. Please try again.";
                _context3.prev = 2;
                _context3.next = 5;
                return _axios.default.put('/integration/productboard/uninstall');

              case 5:
                updatedStoredState = _objectSpread({}, this.state.storedState);
                updatedStoredState.isNoteCreationSettingEnabled = false;
                updatedStoredState.accessToken = '';
                this.setState({
                  isInstalled: false,
                  accessToken: '',
                  isNoteCreationSettingEnabled: false,
                  storedState: updatedStoredState,
                  showUninstallModal: false
                });
                _context3.next = 15;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](2);
                data = _context3.t0.response.data;
                this.setState({
                  messageType: 'error',
                  message: (_data$error2 = data.error) !== null && _data$error2 !== void 0 ? _data$error2 : errorMessage,
                  showUninstallModal: false
                });

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 11]]);
      }));

      function onUninstall() {
        return _onUninstall.apply(this, arguments);
      }

      return onUninstall;
    }()
  }, {
    key: "onClickUninstallButton",
    value: function onClickUninstallButton() {
      this.setState({
        showUninstallModal: true
      });
    }
  }, {
    key: "closeUninstallModal",
    value: function closeUninstallModal() {
      this.setState({
        showUninstallModal: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state2 = this.state,
          isInstalled = _this$state2.isInstalled,
          isNoteCreationSettingEnabled = _this$state2.isNoteCreationSettingEnabled,
          activePanel = _this$state2.activePanel,
          messageType = _this$state2.messageType,
          message = _this$state2.message,
          activeTab = _this$state2.activeTab,
          accessToken = _this$state2.accessToken,
          validationErrorMessage = _this$state2.validationErrorMessage,
          storedState = _this$state2.storedState,
          showActionButtons = _this$state2.showActionButtons,
          showUnsavedChangesModal = _this$state2.showUnsavedChangesModal,
          showUninstallModal = _this$state2.showUninstallModal,
          isSavingNoteCreationSetting = _this$state2.isSavingNoteCreationSetting,
          isSavingCredentials = _this$state2.isSavingCredentials;
      var panelHasUnsavedChanges = this.checkPanelHasUnsavedChanges();
      var enabledIntegrationCount = this.state.storedState.isNoteCreationSettingEnabled ? 1 : 0;
      return (0, _preact.h)(_IntegrationSetup.default, {
        headerTitle: "Productboard",
        appLogoName: "productboard-l",
        appContainerBackgroundColor: "#FFC600",
        dismissMessage: this.dismissMessage,
        messageType: messageType,
        message: message,
        installButton: isInstalled ? (0, _preact.h)(_PanelItems.InstallAndUninstallButtons, {
          onClickUninstallButton: function onClickUninstallButton() {
            return _this3.onClickUninstallButton();
          }
        }) : (0, _preact.h)(_Button.default, {
          size: "medium",
          variant: "brand",
          title: "Install now",
          className: "installation__button_cta",
          onClick: function onClick() {
            return _this3.setActiveTab(1);
          }
        }),
        description: (0, _preact.h)(OverviewDescriptionText, null),
        tabTitles: ['Integration', 'Installation'],
        activeTab: activeTab,
        onClickTab: function onClickTab(selectedTab) {
          return _this3.setActiveTab(selectedTab);
        },
        tabContents: [(0, _preact.h)(_Tabs.IntegrationTab, {
          key: "integrationTab",
          activePanel: activePanel,
          isInstalled: isInstalled,
          isNoteCreationSettingEnabled: isNoteCreationSettingEnabled,
          showActionButtons: showActionButtons,
          onSave: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
            return _regenerator.default.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return _this3.saveNoteCreationSetting();

                  case 2:
                    return _context4.abrupt("return", _context4.sent);

                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          })),
          onCancel: function onCancel() {
            return _this3.resetNoteCreationSetting();
          },
          onSettingChanged: function onSettingChanged() {
            return _this3.onNoteCreationSettingChanged(!isNoteCreationSettingEnabled);
          },
          hasUnsavedChanges: panelHasUnsavedChanges,
          showUnsavedChangesModal: showUnsavedChangesModal,
          displayUnsavedChangedModal: function displayUnsavedChangedModal() {
            return _this3.displayUnsavedChangedModal();
          },
          closeModal: function closeModal() {
            return _this3.closeModal();
          },
          resetChanges: function resetChanges() {
            return _this3.onResetIntegrationTab(1);
          },
          isSavingNoteCreationSetting: isSavingNoteCreationSetting,
          onClickPanelCallback: function onClickPanelCallback(selectedPanel) {
            return _this3.setSelectedPanel(selectedPanel);
          },
          storedState: storedState
        }), (0, _preact.h)(_Tabs.InstallationTab, {
          key: "installationTab",
          accessToken: accessToken,
          isInstalled: isInstalled,
          onSave: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
            return _regenerator.default.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this3.onInstall();

                  case 2:
                    return _context5.abrupt("return", _context5.sent);

                  case 3:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          })),
          onCancel: function onCancel() {
            return _this3.onResetAccessToken();
          },
          onChangeCallback: function onChangeCallback(value) {
            return _this3.setState({
              accessToken: value
            });
          },
          onClickCallback: function onClickCallback() {
            return _this3.setState({
              validationErrorMessage: undefined
            });
          },
          onClickManage: function onClickManage() {
            return _this3.setActiveTab(0);
          },
          onClickUninstall: function onClickUninstall() {
            return _this3.onClickUninstallButton();
          },
          errorMessage: validationErrorMessage,
          hasUnsavedChanges: panelHasUnsavedChanges,
          showUnsavedChangesModal: showUnsavedChangesModal,
          displayUnsavedChangedModal: function displayUnsavedChangedModal() {
            return _this3.displayUnsavedChangedModal();
          },
          closeModal: function closeModal() {
            return _this3.closeModal();
          },
          resetChanges: function resetChanges() {
            return _this3.onResetInstallationTab(0);
          },
          isSavingCredentials: isSavingCredentials
        })],
        uninstallModal: (0, _preact.h)(_UninstallModal.default, {
          headerTitle: "Freshdesk",
          onUninstall: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
            return _regenerator.default.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return _this3.onUninstall();

                  case 2:
                    return _context6.abrupt("return", _context6.sent);

                  case 3:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6);
          })),
          showUninstallModal: showUninstallModal,
          closeUninstallModal: function closeUninstallModal() {
            return _this3.closeUninstallModal();
          },
          enabledIntegrationCount: enabledIntegrationCount
        })
      });
    }
  }]);
  return ProductboardIntegration;
}(_preact.Component);

var OverviewDescriptionText = function OverviewDescriptionText() {
  return (0, _preact.h)("div", null, "Productboard helps product managers understand what customers need, prioritize what to build next, and rally everyone around the roadmap.", (0, _preact.h)("div", {
    className: "description-details"
  }, "With Gainsight ", _constants.PLATFORM_BRAND_NAME_POSSESSIVE_FORM, " Productboard integration, you can easily push community posts to Productboard if they contain user insights for your product team, such as customer ideas or a pain point shared in a reply. From there, product managers can identify valuable insights and link them to related feature ideas, so they\u2019ll be on hand for prioritization."));
};

var _default = ProductboardIntegration;
exports.default = _default;